<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
                      :custom-create-actions="[listBancos, listCuentasBancarias]"
                      @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                            @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedTasaEA" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    :custom-update-selected-data="customUpdateSelectedData"
                    :custom-update-actions="[listBancos, listCuentasBancarias]" :custom-update-collection-data="customUpdateCollectionData"
                    @updateValues="setupUpdateValues"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                              :optionalParams="queries"
                              @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedTasaEA"
                            :load-data="loadDataTasaEA" :entity="entity" :auth-token="authToken"
                            :list-api="listApi" :queries="queries" @updateValues="setupUpdateValues"
                            :custom-update-load-data="customUpdateLoadData">
      <component :is="childFormComponent" :load-data="loadDataTasaEA" :collection-bancos="collectionBancos"
                  :collection-cuentas-bancarias="collectionCuentasBancarias" :custom-update-value-data="customUpdateValueData"
                  @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import {
  copiaProfunda,
  fixDecimals,
  getCurrentMonth
} from "@/common/constants/functions";
import {listCollectionData, useLayoutMain} from "@/layouts/main";
import HeaderComponent from "@/layouts/main/HeaderComponent.vue";
import FilterRefactComponent from "@/layouts/FilterRefactComponent.vue";
import TableComponent from "@/layouts/main/TableComponent.vue";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent.vue";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent.vue";
import TasasEACrearActualizarComponent from "@/components/rendimientos/components/TasasEACrearActualizarComponent.vue";

export default {
  name: 'TasasEACRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    TasasEACrearActualizarComponent,
  },
  data: function () {
    return {
      title: 'Tasas efectivas anuales bancarias',
      entity: {gender: 'f', value: 'tasa efectiva anual'},
      childFormComponent: 'TasasEACrearActualizarComponent',
      tableColumns: {
        'cuentaBancaria.banco.nombre_banco': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre del banco'
        },
        'cuentaBancaria.cuenta_bancaria': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Cuenta bancaria'
        },
        'cuentaBancaria.nombre_cuenta': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre cuenta'
        },
        'tasa_efectiva_anual': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Tasa efectiva anual'
        },
        'tasa_representativa': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Tasa representativa'
        },
        'year': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Año'
        },
        'mes': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Mes'
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const collectionBancos = ref([]);
    const collectionCuentasBancarias = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedTasaEA = ref({
      id: '',
      cuenta_bancaria_id: '',
      tasa_efectiva_anual: '',
      tasa_representativa: '',
      year: '',
      mes: '',
      estado: ''
    });
    const loadDataTasaEA = ref({
      cuenta_bancaria_id: '',
      tasa_efectiva_anual: '',
      tasa_representativa: '',
      year: '',
      mes: ''
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_BANCOTEA_CREATE,
      list: process.env.VUE_APP_NEST_BANCOTEA_FINDALL,
      update: process.env.VUE_APP_NEST_BANCOTEA_UPDATE,
      updateState: process.env.VUE_APP_NEST_BANCOTEA_UPDATESTATE
    });
    const customUpdateValueData = (key, value) => {
      if (['cuenta_bancaria_id', 'tasa_efectiva_anual', 'tasa_representativa', 'year', 'mes'].includes(key)) return Number(value);
      return value;
    };
    const customUpdateSelectedData = (selectedCollectionData) => {
      const updatedSelectedData = {};
      for (const key of Object.keys(selectedTasaEA.value)) {
        updatedSelectedData[key] = customUpdateValueData(key, selectedCollectionData[key]);
      }
      selectedTasaEA.value = updatedSelectedData;
    }
    const customUpdateLoadData = () => {
      for (const key in loadDataTasaEA.value) {
        let value = loadDataTasaEA.value[key];
        value = customUpdateValueData(key, value);
      }
    };
    const customUpdateCollectionData = () => {
      const copyCollectionData = copiaProfunda(collectionData.value);
      for (const copyData of copyCollectionData) {
        copyData['tasa_efectiva_anual'] = fixDecimals(copyData['tasa_efectiva_anual']) + '%';
        copyData['tasa_representativa'] = fixDecimals(copyData['tasa_representativa']) + '%';
        copyData['mes'] = getCurrentMonth(copyData['mes']);
      }
      return copyCollectionData;
    };
    const listBancos = async () => await listCollectionData(process.env.VUE_APP_NEST_BANCO_FINDALL, {'collectionBancos': collectionBancos}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    const listCuentasBancarias = async () => await listCollectionData(process.env.VUE_APP_NEST_CUENTABANCARIA_FINDALL, {'collectionCuentasBancarias': collectionCuentasBancarias}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedTasaEA, loadDataTasaEA, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedTasaEA,
      loadDataTasaEA,
      listApi,
      paginate,
      queries,
      collectionBancos,
      collectionCuentasBancarias,
      setupUpdateValues,
      cleanLoadSelectedData,
      listBancos,
      listCuentasBancarias,
      customUpdateSelectedData,
      customUpdateCollectionData,
      customUpdateLoadData,
      customUpdateValueData,
    };
  },
}
</script>